import { baseApi } from '../app/baseApi';
import { Family } from "@mekimix/shared/dist/types/Family";
import { addFamilyInput, updateFamilyInput } from '../features/families/familySchema';

export const familyAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getFamilyById: builder.query<Family, string>({
      query: (id) => `/families/${id}`,
      providesTags: ['Family'],
    }),
    updateFamily: builder.mutation<{ massage: string }, { id: string; familyData: updateFamilyInput }>({
      query: ({ id, familyData }) => ({
        url: `/families/${id}`,
        method: "PATCH",
        body: familyData,
      }),
      invalidatesTags: ["Family"],
    }),
    getFinancialSummary: builder.query<
      { summary: { month: string; income: number; expenses: number; debts: number }[] },string>({
      query: (familyId) => `/families/${familyId}/financial-summary`,
    }),
    updateFamilyStatus: builder.mutation<void, { id: string; status: string }>({
      query: ({ id, status }) => ({
        url: `/families/${id}/status`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ["Family"],
    }),
    getAllFamilies: builder.query<any[], void>({
      query: () => "/families",
      providesTags: ["Family"],
    }),
    removeFamily: builder.mutation<void, string>({
      query: (id) => ({
        url: `/families/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Family"],
    }),
    addFamily: builder.mutation<{ message: string }, addFamilyInput>({
      query: (familyData) => ({
        url: 'families',
        method: 'POST',
        body: familyData,
      })
    }),getFamiliesAddedThisYear: builder.query<{ count: number }, void>({
        query: () => '/families/added-this-year',
    }),

  }),
});

export const { useGetFamilyByIdQuery,
  useUpdateFamilyMutation,
  useUpdateFamilyStatusMutation,
  useGetAllFamiliesQuery,
  useRemoveFamilyMutation,
  useAddFamilyMutation,
  useGetFinancialSummaryQuery,
    useGetFamiliesAddedThisYearQuery,
} = familyAPI;

